import { SuperAdminConstants } from '../../../_constants';

const initialState = { editAssignMetricLoading: true, data: '', error: false };

export function editAssignMetricListReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_EDIT_EXISTING_METRIC:
            return {
                editAssignMetricListLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_EDIT_EXISTING_METRIC:
            return {
                editAssignMetricListLoading: false,
                data: action,
                error: false
            };
        case SuperAdminConstants.EDIT_EXISTING_METRIC_ERROR:
            return {
                editAssignMetricListLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AssignMetric/editExistingCompetencyAssignMetric.reducer.js